import { UserInfo } from 'hub-http/userInfo';
import { createContext } from 'react';

export const AuthContext = createContext<UserInfo | undefined>(undefined);
